import { useEffect, useReducer } from "react";
import { resolvedTheme, setPreference, storedPreference, subscribe } from "../utils/theme";

// Returns the resolved theme ("light" or "dark"), the stored preference
// ("system", "light" or "dark"), and the setter.
//
// The preference and the resolved theme are different questions and the UI
// needs both. A picker has to show "System" as selected even though what is
// on screen is light or dark, and going from "dark" back to "system" on a
// phone already in dark mode changes the preference without changing a single
// colour. Returning only the resolved theme made that transition invisible.
//
// Re-reading on each render rather than holding a copy in state: both values
// come from localStorage and a media query, so a cached copy is one more thing
// that can disagree with the source. The reducer exists only to re-render when
// something else changes them.
export function useTheme() {
  const [, rerender] = useReducer((n) => n + 1, 0);
  useEffect(() => subscribe(rerender), []);

  return {
    theme: resolvedTheme(),
    preference: storedPreference(),
    setPreference,
  };
}

export default useTheme;
